import { useQuery } from "react-query";
import { getCrops } from "@/api/Maintainers/crops-api";

export const key = "maintainer-crops";

export function useCrops() {
	return useQuery([key], () => getCrops());
}
